import React from 'react';

const PRESS_RELEASE_URL = 'https://businesscloud.co.uk/news/manchester-startups-partner-to-launch-compliance-platform/';

export default function MercurySupportSection() {
  return (
    <section className="py-16 sm:py-24 bg-zapt-navy border-t border-white/10 relative z-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4">
          Built With Partners Who Get It
        </h2>
        <p className="text-gray-400 text-center mb-12 sm:mb-16 max-w-2xl mx-auto text-base sm:text-lg">
          Mercury Support — a compliance specialist with decades of experience in hospitality and multi-site operations — came to us to build a platform that would actually fit how their clients work.
        </p>

        <div className="rounded-2xl border bg-zapt-purple/10 backdrop-blur-sm border-zapt-purple/30 overflow-hidden">
          <div className="p-6 sm:p-8 lg:p-12">
            <p className="text-xl sm:text-2xl text-white font-medium leading-relaxed mb-8">
              &ldquo;We built this platform to solve the recurring challenges we&apos;ve faced ourselves and have seen our clients struggle with — too much paperwork, disconnected systems, and not enough clarity. Our goal was simple — one platform that keeps businesses audit-ready, easy to use for teams on the ground, and supported by real people who understand the pressures operators face every day.&rdquo;
            </p>
            <p className="text-zapt-yellow font-semibold mb-1">Dave Mansbridge</p>
            <p className="text-gray-400 text-sm mb-6">Founder, Mercury Support</p>

            <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <p className="text-gray-400 text-sm sm:text-base">
                A cloud-based compliance platform for health, safety and risk management. Now live across hospitality, education and facilities — helping organisations stay audit-ready without the paperwork.
              </p>
              <a
                href={PRESS_RELEASE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 inline-flex items-center gap-2 text-zapt-yellow font-medium hover:gap-3 transition-all"
              >
                Read the press release
                <span aria-hidden>↗</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
